<template>
  <div class="wpcm-product-info">
    <h3>Product Donation Info</h3>
    <div class="wpcm-product-details">
      <div class="wpcm-product-item">
        <span class="wpcm-label">Item Price:</span>
        <span class="wpcm-value">{{ getSymbol() }}{{ getItemPrice() }}</span>
      </div>
      <div class="wpcm-product-item">
        <span class="wpcm-label">Quantity:</span>
        <span class="wpcm-value">{{ getQuantityText() }}</span>
      </div>
      <div class="wpcm-product-item wpcm-total">
        <span class="wpcm-label">Total Amount:</span>
        <span class="wpcm-value">{{ getSymbol() }}{{ getConvertedTotal() }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useDonationFormsStore } from '../store';

const store = useDonationFormsStore();

const props = defineProps({
  product_total: {
    type: Number,
    required: true
  },
  symbol: {
    type: String,
    required: true
  },
  symbols: {
    type: Object,
    default: () => ({})
  },
  quantity: {
    type: Object,
    required: true
  },
  strings: {
    type: Object,
    default: () => ({})
  }
});

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return props.symbols[store.currency] != undefined ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation;
  const syb = store.currency;
  if (_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt.toFixed(2);
};

const getConvertedTotal = () => {
  return convert(props.product_total);
};

const getItemPrice = () => {
  // Calculate item price by dividing total by total quantity
  const totalQuantity = Object.values(props.quantity).reduce((sum: number, qty: any) => sum + parseInt(qty), 0);
  const itemPrice = totalQuantity > 0 ? (props.product_total / totalQuantity) : props.product_total;
  return convert(itemPrice);
};

const getQuantityText = () => {
  const items = Object.entries(props.quantity).map(([id, qty]) => `${qty} item(s)`);
  return items.join(', ');
};

onMounted(() => {
  console.log('ProductDonationInfo mounted with props:', props);
  console.log('product_total:', props.product_total);
  console.log('quantity:', props.quantity);
});
</script>

<style scoped>
.wpcm-product-info {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.wpcm-product-info h3 {
  margin: 0 0 15px 0;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
}

.wpcm-product-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wpcm-product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.wpcm-product-item:last-child {
  border-bottom: none;
}

.wpcm-product-item.wpcm-total {
  font-weight: bold;
  font-size: 16px;
  color: #28a745;
  border-top: 2px solid #28a745;
  padding-top: 12px;
  margin-top: 8px;
}

.wpcm-label {
  color: #6c757d;
  font-weight: 500;
}

.wpcm-value {
  color: #495057;
  font-weight: 600;
}
.wpcm-product-info{
    width: 100%;
}
</style>